import { gql } from '@apollo/client';

export const ADMIN_ORGANIZATIONS_QUERY = gql`
  query AdminOrganizations(
    $after: String
    $first: Int
    $orderBy: String
    $order: String
    $search: String
  ) {
    adminOrganizations(
      after: $after
      first: $first
      orderBy: $orderBy
      order: $order
      search: $search
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        name
        stripeCustomerId
        hubspotDealId
        lastInvoiceNumber
        createdAt
        users {
          id
          magicLoginLink
        }
        venues {
          id
          name
        }
      }
    }
  }
`;
